import React, {Component} from 'react'
import Header from '../tags/Header'
import Help from '../tags/Help'
import {getCourseId} from '../../helpers/course'
import {getStudentProgress} from '../../services/vu'
import {withRouter} from 'react-router-dom'
import parse from 'html-react-parser';

class ErrorWithHtmlParser extends Component {
  constructor(props) {
    super(props)

    this.state = {
      drawerOpen: false
    }
  }

  componentDidMount() {
    this.trackCustomRouteChange()
  }

  trackCustomRouteChange = () => {
    if (getCourseId()) {
      getStudentProgress(getCourseId()).then(progress => {
        window.dataLayer.push(this.getCustomRouteChangePayload(getCourseId(), progress.id))
      }, () => {
        window.dataLayer.push(this.getCustomRouteChangePayload(getCourseId()))
      })
    } else {
      window.dataLayer.push(this.getCustomRouteChangePayload())
    }
  }

  getCustomRouteChangePayload = (courseId, processId) => {
    return {
      event: 'custom.route.change',
      route: {
        current: this.props.location.pathname,
        previous: undefined,
        title: this.props.title,
      },
      data: {
        value: undefined,
        courseId: courseId,
      },
      processId: processId,
    }
  }

  render() {
    return (
      <div>
        <Header
          onHamburgerClick={() => this.setState({
            drawerOpen: true
          })}
        />
        <Help
          open={this.state.drawerOpen}
          onClose={() => this.setState({
            drawerOpen: false
          })}
        />
        <div className={`page page__error ${this.props.className}`}>

          <h1>{this.props.title}</h1>


          <div className="content-container">
            {this.props.description ? <div className="txt-lg">{this.props.description}</div> : null}
            {this.props.longDescription ? <div className="txt-md">{parse(this.props.longDescription)}</div> : null}
            {this.props.contactInfo ? <div className="txt-md">{parse(this.props.contactInfo)}</div> : null}
            {this.props.hideContactInfo ? null : <p className="txt-md">Please <a href="https://www.vu.edu.au/contact-us" target="_blank">contact VUHQ</a> for further information.</p>}
            {this.props.bottomDescription ? <div className="txt-md">{parse(this.props.bottomDescription)}</div> : null}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ErrorWithHtmlParser)
